import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { AuthProvider } from './context/AuthContext';
import { AdminApp } from './AdminApp';
import './admin-style.css';

export function AdminRoot() {
  return (
    <AuthProvider>
      <AdminApp />
    </AuthProvider>
  );
}
